<app-react-frame *ngIf="frameUrl" [src]="frameUrl" title="Nexedu"></app-react-frame>
